import { useEffect, useState } from 'react';

import { DeclarationHighValueGroupType } from '@e-origin/shared';

import { ALLOWED_HV_REQUESTED_PROCEDURES } from '@constants';
import { useFinalizeFieldRules } from '../policy';

interface Params {
  onSave: (newGroup: string) => Promise<void>;
}

export const useDeclarationProfileChange = ({ onSave }: Params) => {
  const { form } = useFinalizeFieldRules();
  const [pendingGroup, setPendingGroup] = useState<string | null>(null);

  const formGroup = form.values.generalInfo?.group as DeclarationHighValueGroupType | undefined;

  useEffect(() => {
    const additionalProcedure = form.values.declarationGoods.additionalProcedure as string[] | undefined;
    if (formGroup === DeclarationHighValueGroupType.H5 && !additionalProcedure?.includes('F15')) {
      form.setFieldValue('declarationGoods.additionalProcedure', [...(additionalProcedure || []), 'F15']);
    }
  }, [formGroup]);

  const requestChange = (newValue: string) => {
    if (!newValue || newValue === formGroup) {
      return;
    }

    setPendingGroup(newValue);
  };

  const confirmChange = async () => {
    const newValue = pendingGroup;
    setPendingGroup(null);
    form.setFieldValue('generalInfo.group', newValue);
    await onSave(newValue);
  };

  const allowedProcedures: string[] = ALLOWED_HV_REQUESTED_PROCEDURES[formGroup] ?? [];

  return { formGroup, allowedProcedures, pendingGroup, setPendingGroup, requestChange, confirmChange };
};
